<template>

    <div>
        <div class="row  no-gutters pt-xl-4 mb-xl-6">
            <div class="col-xl-3 col-6 tab-test-bird order-xl-1 order-2">

            </div>
            <div class="col-xl-6 col-12 tab-test-title order-xl-2 order-1 text-center pt-xl-3 mt-xl-0 mt-4"
                 v-if="lesson">
                {{lesson.lesson}}
            </div>
            <div class="col-xl-3 col-6 tab-video-points test-line order-xl-3 order-3" v-if="points && testmode==0">
                <div class="zerno-points">
                    {{points}}
                </div>
            </div>
            <div class="col-xl-12 col-12 tab-video-notice order-xl-4 order-4 text-center mt-xl-n7 mt-n5 mb-xl-0 mb-3">
                <div class="tab-video-notice-1">{{ $t('test') }} {{$t('№')}}{{ test.pos }}
                    <span class="ml-2" v-if="testsCount > 0">({{test.pos}} {{$t('of')}} {{testsCount}})</span>
                </div>
            </div>

            <div class="col-12 order-10 text-center" v-if="showTestIntro && test">

                <h2 class="mt-7" v-if="test.test">{{ test.test }}</h2>
                <h2 class="mt-7" v-else>{{ $t('test') }} {{$t('№')}}{{ test.pos }}</h2>
                <h1 class="mb-5 mt-2" v-if="test.description">«{{ test.description }}»</h1>
                <button
                        class="btn btn-success btn-large btn-lg mb-9 btn-to-next-lesson"
                        @click="startTest">
                    <i class="ni ni-spaceship mr-2"></i>{{ $t('start_test') }} {{$t('№')}}{{ test.pos }}
                </button>

            </div>

            <div class="col-12 order-10" v-if="!showTestIntro && test">

                <div class="row ml-xl-0 mr-xl-0 ml-3 mr-3 justify-content-center">

                    <div class="col-xl-12 col-12 test-question-content text-center mt-xl-n4"
                         v-if="currentTask.testtask">
                        <span v-if="currentTask.pos && !currentTask.testtask.startsWith($t('№')+currentTask.pos)"
                              class="mr-3">{{$t('№')}}{{currentTask.pos}}.</span>{{ currentTask.testtask }}
                    </div>

                    <div class="col-12 tab-video-notice-2 text-center pl-xl-0 pl-6 pr-xl-0 pr-6 mb-xl-4"
                         v-if="test.description && test.description !== currentTask.testtask">{{
                        test.description }}
                    </div>

                    <div class="col-xl-8 col-12 mb-xl-4 mb-4 mt-3">
                        <div class="row no-gutters">
                            <div v-for="(item, i) in cards"
                                 :key="i"
                                 class="col text-center mb-2">
                                <vue-flip v-model="item.flipped"
                                          width="150px"
                                          height="200px"
                                          class="ma-1"
                                          @click.native="cardClick(item)">
                                    <template v-slot:front>
                                        <div class="flip-front blue py-4">
                                            <!--v-img
                                              :src="Рубашка карты"
                                              class="my-3"
                                              contain
                                            /-->
                                        </div>
                                    </template>
                                    <template v-slot:back>
                                        <div :class="['flip-back', 'py-4', { 'not-raised' : item.found}]">
                                            <div
                                                    v-if="item.image===null"
                                                    class="mt-12 justify-center">
                                                {{ item.word }}
                                            </div>
                                            <img v-if="item.image"
                                                 :src="item.image"
                                                 class="my-3"
                                            />
                                        </div>
                                    </template>
                                </vue-flip>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row mb-4 mt-1 justify-content-center no-gutters" v-if="!showTestIntro && test">
            <button
                    class="btn btn-info"
                    @click="skip"
            >
                {{ $t('omit_task') }} &rarr;
            </button>
        </div>
    </div>
</template>
<style src="@/assets/poliglotiki/main.css">
</style>
<style>
    .flip-container {
        margin: 0 auto;
    }
</style>
<script>
    import Vue from 'vue'
    import api from '@/utils/api'
    import VueFlip from 'vue-flip'

    export default {
        name: 'Test5',
        components: {
            'vue-flip': VueFlip,
        },
        props: {
            idtest: {default: null},
            lesson: {type: Object, default: null},
            points: {default: null},
            testsCount: {default: null},
            showButtons: {type: Boolean, default: true},
            testmode: {default: 0},
        },
        data: () => ({
            test: {},
            testtasks: [],
            testelements: [],
            cards: [],
            cardSelected: [],
            taskIdx: 0,
            audio: new Audio(),

            forceRenderKey: 0,

            showTestIntro: true,

            errorChord: 'https://www.poliglotiki.ru/images/pol-mp3/error_chord.mp3',
            okChord: 'https://www.poliglotiki.ru/images/pol-mp3/ok.mp3',
        }),

        computed: {
            currentTask: function () {
                console.log('currentTask')
                return (this.taskIdx < this.testtasks.length) ? this.testtasks[this.taskIdx] : {}
            },

            mainElement: function () {
                console.log('mainElement', this.getBy('ismain', 1, this.testelements))
                return this.getBy('ismain', 1, this.testelements)
            },

            answers: function () {
                console.log('answers')
                return this.testelements.filter(function (e) {
                    return !e.ismain
                })
            },
        },

        watch: {
            taskIdx: async function () {
                this.loadTask()
            },
        },

        async mounted() {
            api({url: '/tests/' + this.idtest}).then(resp => {
                this.test = resp.data
            })
            const response = await api({url: '/testtasks?sort=pos' + (this.idtest ? '&filter[idtest]=' + this.idtest : '')})
            this.testtasks = response.data
            this.loading = false
        },
        methods: {
            async startTest() {
                if (this.testtasks.length) {
                    if (this.test.audio) {
                        await this.play(this.test.audio)
                    }
                    this.showTestIntro = false
                    this.loadTask()
                }
            },
            async loadTask() {
                if (this.currentTask.idtesttask) {
                    this.cardSelected = []
                    const response = await api({
                        method: 'get',
                        url: '/testelements?filter[idtesttask]=' + this.currentTask.idtesttask
                    })
                    this.testelements = response.data
                    this.testelements = this.testelements.map(e => {
                        e.flipped = false;
                        e.found = false;
                        return e
                    })
                    this.cards = this.testelements.map(a => ({...a})) // clone
                    let words = this.testelements.map(a => ({...a})) // clone
                    words = words.map(e => {
                        e.image = null;
                        return e
                    })
                    this.cards = this.shuffle(this.cards.concat(words))
                } else {
                    this.$emit('testComplete')
                }
            },
            getBy(propname, value, array) {
                for (let index = 0; index < array.length; index++) {
                    if (array[index][propname] === value) return array[index]
                }

                return {}
            },

            shuffle(a) {
                for (let i = a.length - 1; i > 0; i--) {
                    const j = Math.floor(Math.random() * (i + 1));
                    [a[i], a[j]] = [a[j], a[i]]
                }
                return a
            },

            cardClick(card) {
                console.log(card)
                if (!card.found && !card.flipped) {
                    if (this.cardSelected.length < 2) {
                        // card.flipped = true
                        Vue.set(card, 'flipped', true)
                        this.cardSelected.push(card)
                        if (this.cardSelected.length === 2) {
                            setTimeout(async () => {
                                if (this.cardSelected[0].idtestelement === card.idtestelement) {
                                    this.cardSelected[0].found = true
                                    card.found = true
                                    if (card.audio) {
                                        await this.play(card.audio)
                                    } else {
                                        await this.play(this.okChord)
                                    }
                                    if (this.cards.length === this.getFlipped()) {
                                        this.$emit('correctAnswer')
                                        this.$emit('testComplete')
                                    }
                                } else this.cardSelected.map(el => {
                                    el.flipped = false;
                                    return el
                                })
                                this.cardSelected = []
                            }, 1000)
                        }
                    }
                }
            },

            getFlipped() {
                let flipped = 0
                this.cards.forEach( (card) => {
                    if (card.flipped) flipped++;
                })
                return flipped
            },

            skip: function () {
                this.$emit('wrongAnswer', {test: this.test.test, taskIdx: this.taskIdx, error: 'Пропущено'})
                this.taskIdx++
            },

            play: function (path) {
                return new Promise((resolve) => {
                    if (path) {
                        this.audio.src = path
                        this.audio.play()
                        this.audio.onended = function () {
                            console.log('Звук закончился')
                            resolve()
                        }

                        this.audio.onerror = function () {
                            console.log('Звук error')
                            resolve()
                        }
                    } else {
                        resolve()
                    }
                })
            },
        },
    }
</script>
